var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { hashMessage } from '../utils/hash';
import { generateId } from '../utils/id';
let currentMessage = null;
let lastMessage = null;
let displayName = '';
const seenMsgIds = new Set();
export function setDisplayName(name) {
    displayName = name;
}
export function getDisplayName() {
    return displayName;
}
export function getLastMessage() {
    return lastMessage;
}
export function getCurrentMessage() {
    return currentMessage;
}
export function isDuplicateMessage(msgId) {
    return seenMsgIds.has(msgId);
}
export function registerMessageId(msgId) {
    seenMsgIds.add(msgId);
}
export function createMessage(content) {
    return __awaiter(this, void 0, void 0, function* () {
        let lastHash = null;
        if (lastMessage) {
            const lastJson = JSON.stringify({
                ver: lastMessage.ver,
                timestamp: lastMessage.timestamp,
                last_hash: lastMessage.last_hash,
                msg_id: lastMessage.msg_id,
                msg_content: lastMessage.msg_content,
                display_name: lastMessage.display_name,
            });
            lastHash = yield hashMessage(lastJson);
        }
        const msg = {
            ver: 1,
            timestamp: Date.now(),
            last_hash: lastHash,
            msg_id: generateId(),
            msg_content: content,
        };
        if (displayName) {
            msg.display_name = displayName;
        }
        currentMessage = msg;
        return msg;
    });
}
export function processScannedMessage(jsonString) {
    try {
        const parsed = JSON.parse(jsonString);
        if (typeof parsed.ver !== 'number' ||
            typeof parsed.timestamp !== 'number' ||
            typeof parsed.msg_id !== 'string' ||
            typeof parsed.msg_content !== 'string' ||
            parsed.msg_content.length > 512 ||
            parsed.display_name.length > 24) {
            return null;
        }
        const msg = {
            ver: parsed.ver,
            timestamp: parsed.timestamp,
            last_hash: typeof parsed.last_hash === 'string' ? parsed.last_hash : null,
            msg_id: parsed.msg_id,
            msg_content: parsed.msg_content,
            display_name: typeof parsed.display_name === 'string' ? parsed.display_name : undefined,
        };
        lastMessage = msg;
        currentMessage = msg;
        return msg;
    }
    catch (_a) {
        return null;
    }
}
export function setLastMessage(msg) {
    lastMessage = msg;
}
